import { render } from "./RecipeMetadata.vue?vue&type=template&id=1dde75c2&scoped=true&ts=true"
import script from "./RecipeMetadata.vue?vue&type=script&lang=ts"
export * from "./RecipeMetadata.vue?vue&type=script&lang=ts"

import "./RecipeMetadata.vue?vue&type=style&index=0&id=1dde75c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dde75c2"]])

export default __exports__